import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/newsList',
    name: 'newsList',
    component: () => import('@/views/news/list.vue')
  },
  {
    path: '/newsDetails',
    name: 'newsDetails',
    component: () => import('@/views/news/details.vue')
  },
  {
    path: '/productList',
    name: 'productList',
    component: () => import('@/views/product/list.vue')
  },
  {
    path: '/productDetails',
    name: 'productDetails',
    component: () => import('@/views/product/details.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/page/about.vue')
  },
  {
    path: '/cooperate',
    name: 'cooperate',
    component: () => import('@/views/page/cooperate.vue')
  },
  {
    path: '/jobs',
    name: 'jobs',
    component: () => import('@/views/page/jobs.vue')
  },
  {
    path: '/concant',
    name: 'concant',
    component: () => import('@/views/page/concant.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
